module.exports = __webpack_public_path__ + "static/img/dialog1.3a6ec7a.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/mobile_img/common/dialog1.png
// module id = OGBA
// module chunks = 7